import {
    OpType,
    SubscriptionMessage
} from '@aws-amplify/datastore';

import { ContextAwareIdentifier } from '../design/document/ContextAwareIdentifier';
import { DataStore } from 'aws-amplify';
import { ModelType } from '../design/document/ModelType';
import { StateContext } from '../design/document/state/StateContext';
import { WorkSpecification } from '../../models';
import { useRecoilCallback } from 'recoil';
import { workSpecificationByWorkSpecificationIdentifierSelectorFamily } from '../design/document/state/DocumentState';

let subscription: ZenObservable.Subscription | undefined;

export const useWorkSpecificationSubscription = () => {
    const handleWorkSpecificationUpdate = useRecoilCallback(({ set, reset }) => async (message: SubscriptionMessage<WorkSpecification>, context: StateContext) => {
        const workSpecificationIdentifier = new ContextAwareIdentifier(message.element.id, context, ModelType.WORK_SPECIFICATION);

        if (message.opType === OpType.DELETE) {
            reset(workSpecificationByWorkSpecificationIdentifierSelectorFamily(workSpecificationIdentifier));
            return;
        }

        const workSpecification = message.element;
        set(workSpecificationByWorkSpecificationIdentifierSelectorFamily(workSpecificationIdentifier), workSpecification);
    });

    const subscribe = async (propertyId: string) => {
        subscription = DataStore.observe(WorkSpecification, (workSpecification) =>
            workSpecification.propertyId("eq", propertyId)
        ).subscribe({
            next: (message: SubscriptionMessage<WorkSpecification>) => {
                handleWorkSpecificationUpdate(message, StateContext.INSPECTION);
            },
            error: (error) => console.warn(error)
        });
    };

    const unsubscribe = () => {
        subscription?.unsubscribe();
    };

    return { subscribe, unsubscribe };
};